import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/error')({
  component: RouteComponent,
});

function RouteComponent() {
  throw new Error('Oh no!');

  return <div>Hello &quot;/error&quot;!</div>;
}
